export const calculatePercentageBetween = (low: number, high: number, current: number) => {
    return ((current - low) / (high - low)) * 100;
};

export const calculatePercentageChange = (openPrice: number, currentPrice: number) =>
    ((currentPrice - openPrice) / openPrice) * 100;
